import { useState, useEffect } from 'react';
import { memoize } from 'underscore';
import http from 'hub-http/clients/apiClient';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function addFetchContentSupportedLanguagesFailedAlert() {
  FloatingAlertStore.addAlert({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ContentComponents.language.fetchContentSupportedLanguages.failed.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ContentComponents.language.fetchContentSupportedLanguages.failed.message"
    }),
    type: 'danger'
  });
  return [];
}
const cachedFetchContentSupportedLanguages = memoize(() => http.get('cos-domains/v1/domain-setup-tasks/supported-languages').then(({
  objects
}) => objects.map(({
  tag
}) => tag)).catch(addFetchContentSupportedLanguagesFailedAlert));
function useContentSupportedLanguages() {
  const [isLoading, setIsLoading] = useState(true);
  const [contentSupportedLanguages, setContentSupportedLanguages] = useState([]);
  useEffect(() => {
    cachedFetchContentSupportedLanguages().then(setContentSupportedLanguages).finally(() => setIsLoading(false)).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  }, []);
  return {
    contentSupportedLanguages,
    isLoading
  };
}
export const clearCachedContentSupportedLanguagesForTesting = () => {
  cachedFetchContentSupportedLanguages.cache = {};
};
export default useContentSupportedLanguages;